export function formatRelativeDate(dateString: string): string {
  const inputDate = new Date(dateString);
  const now = new Date();

  const diffTime = now.getTime() - inputDate.getTime();
  const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

  const timeOptions: Intl.DateTimeFormatOptions = {
    hour: 'numeric',
    minute: 'numeric',
    hour12: true,
  };
  const formattedTime = inputDate.toLocaleTimeString(undefined, timeOptions);

  if (diffDays === 0) {
    return `Today at ${formattedTime}`;
  } else if (diffDays === 1) {
    return `Yesterday at ${formattedTime}`;
  } else {
    return `${diffDays} days ago`;
  }
}
